import * as React from 'react'
import { SVGAttributes } from 'react'

import * as thirdparty from './thirdParty'
import * as stroke from './stroke'

type SvgSpritesheetProps = SVGAttributes<SVGElement>

export function SvgSpritesheet({
  xmlns = 'http://www.w3.org/2000/svg',
  ...props
}: SvgSpritesheetProps): React.ReactElement<SvgSpritesheetProps> {
  return (
    <svg xmlns={xmlns} {...props}>
      <defs>
        <thirdparty.FacebookSymbol />
        <thirdparty.InstagramSymbol />
        <thirdparty.LinkedInSymbol />
        <thirdparty.TikTokSymbol />
        <thirdparty.TwitterSymbol />
        <thirdparty.YoutubeSymbol />

        <stroke.CaretDownSymbol />
        <stroke.Stack3dSymbol />
      </defs>
    </svg>
  )
}
